import { Component} from '@angular/core';
import {SafeUrlPipe}  from './safe-url.pipe'

@Component({
  selector: 'app-findus',
  imports:[SafeUrlPipe],
  standalone: true,
  templateUrl:'./findus.component.html' ,
  styleUrls: ['./findus.component.css'] 
})
export class FindusComponent  {
 
  address = '2/40 NETAI NAGAR, PURBALOK, MUKUNDAPUR, KOLKATA-700099';
 mapUrl = 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3686.2525071628556!2d88.39944247952188!3d22.494707426811203!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0273b415104303%3A0xd637774956fe59d4!2sSpice%20Trail%20Boutique%20Kitchen%20and%20Catering%20Services!5e0!3m2!1sen!2sin!4v1748170179833!5m2!1sen!2sin';
  phone = '+91 8240714593';
  email = 'TBD';
}


